var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.475 19.5236V19.525V40.475C54.475 44.9256 53.1503 48.4176 50.7714 50.7964C48.3926 53.1753 44.9006 54.5 40.45 54.5H19.525C15.0744 54.5 11.5826 53.1753 9.20377 50.7935C6.82489 48.4117 5.5 44.9134 5.5 40.45V19.525C5.5 15.0744 6.82468 11.5824 9.20355 9.20355C11.5824 6.82468 15.0744 5.5 19.525 5.5H40.475C44.9257 5.5 48.4175 6.82472 50.7931 9.20333C53.1686 11.5818 54.4872 15.0734 54.475 19.5236Z",
    fill: "#FFC48D",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1992 31.1746C42.1992 30.1996 41.4242 29.4246 40.4492 29.4246C39.4742 29.4246 38.6992 30.1996 38.6992 31.1746V31.6246L31.8992 24.8246C31.5242 24.4496 31.0242 24.2746 30.4992 24.3246C29.9742 24.3746 29.4992 24.6496 29.2242 25.0996L26.6742 28.8996L20.7742 22.9496C20.0992 22.2746 18.9992 22.2746 18.2992 22.9496C17.6242 23.6246 17.6242 24.7246 18.2992 25.4246L25.7492 32.8746C26.1242 33.2496 26.6242 33.4246 27.1492 33.3746C27.6742 33.3246 28.1492 33.0496 28.4242 32.5996L30.9742 28.7996L36.2492 34.0746H35.7992C34.8242 34.0746 34.0492 34.8496 34.0492 35.8246C34.0492 36.7996 34.8242 37.5746 35.7992 37.5746H40.4492C40.6742 37.5746 40.8992 37.5246 41.1242 37.4496C41.5492 37.2746 41.8992 36.9246 42.0742 36.4996C42.1742 36.2746 42.1992 36.0496 42.1992 35.8246V31.1746Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCard2);
export default __webpack_public_path__ + "static/media/banner-card-2.58f9eaa0c6eec2e97b929a20e0bbb167.svg";
export { ForwardRef as ReactComponent };